angular.module('wco.directives.packaging', [])
.controller('WcoPackagingController', ['$scope', function($scope) {
    $scope.checkIfItemIsFromOtherPackingSlip = function(item){
        return item.PACKING_SLIP_ID != $scope.packingSlip.PACKING_SLIP_ID;
    };

    $scope.getItemClass = function(item){
        let itemClass = '';
        if($scope.checkIfItemIsFromOtherPackingSlip(item)){
            itemClass = itemClass + 'item-from-other-slip ';
        }

        return itemClass;
    };
}])
.directive('wcoPackaging', ['$timeout', function($timeout) {
    return {
        controller: 'WcoPackagingController',
        controllerAs: 'PackagingController',
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || 'angular/directives/packaging.html';
        },
        replace: true,
        scope:{
            packing: '=',
            packingSlip: '='
        },
        link: function(scope, element, attrs, ngModelController) {
            if (typeof(window.__wco_vars) == 'undefined'){
                window.__wco_vars = {
                    scopes: {
                        packaging: {

                        }
                    }
                }
            }
            if (typeof(window.__wco_vars.scopes.packaging.packages) == 'undefined'){
                window.__wco_vars.scopes.packaging.packages = {};
            }

            window.__wco_vars.scopes.packaging.packages[scope.packing.PACKAGE_ID] = scope;

            $(element).droppable({
                accept: ".available-item",
                activeClass: "ui-state-hover",
                hoverClass: "ui-state-active",
                drop: function( event, ui ) {
                    var packingId = $(this).find('table').data('packingId');
                    var itemId = $(ui.draggable[0]).data('itemId');

                    var currentScope = window.__wco_vars.scopes.packaging.packages[packingId];
                    currentScope.$emit('droppedAvailableItem', {packingId: packingId, itemId: itemId});
                }
            });
        }
    };
}]);